import { Feedback } from "@iunctim/component-feedback/Resources/Public/Scripts/features/Feedback.js";

/**
 * The PreElement class is used to manipulate
 * preformatted elements like <pre>
 */
export class PreElement {
    private static instance: PreElement;

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        const preElements = this.preElements;

        this.addCopyButton(preElements);
    }

    /**
     * Method to instantiate the
     * pre on the current page
     *
     * @returns {PreElement}
     */
    public static use(): PreElement {
        if (!PreElement.instance) {
            PreElement.instance = new PreElement();
        }
        return PreElement.instance;
    }

    /**
     * Selects the pre elements
     *
     * @returns {NodeListOf<HTMLPreElement>}
     */
    protected get preElements(): NodeListOf<HTMLPreElement> {
        return document.querySelectorAll(".text pre");
    }

    /**
     * Method to add a copy button to pre elements
     *
     * @param {NodeListOf<HTMLPreElement>} elements
     * @returns {void}
     */
    private addCopyButton(elements: NodeListOf<HTMLPreElement>): void {
        elements.forEach((element) => {
            element.innerHTML = `<svg
                role="button"
                aria-label="${window.translations?.["button.copyCode"] ?? "Copy code"}"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="icon-sm"
            >
                <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
                <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
            </svg>${element.innerHTML}`;

            const button = element.querySelector("svg");
            button?.addEventListener("click", () => {
                const code = element.querySelector("code") || element;
                const text = (code.textContent || "").trim();

                navigator.clipboard.writeText(text).then(() => {
                    Feedback.flash(
                        button,
                        "success",
                        window.translations?.["feedback.copied"] ?? "Copied!",
                    );
                });
            });
        });
    }
}
